import { FC } from 'react'
import axios from 'axios'

import { ApplicationAttachment } from "../../modules/core/applications"
import { KTSVG } from '../../../_metronic/helpers'
import { downloadFile, extractFilename, getErrorMessage } from '../helpers'
import toast from 'react-hot-toast'

type Props = {
  file?: ApplicationAttachment
  onSuccess?: () => void
}

const API_URL = process.env.REACT_APP_API_URL;

export const ApplicationFileDownload:FC<Props> = ({file, onSuccess}) => {

  const onDownloadFile = async() => {
    if (! file?.id) return;

    await toast.promise(
      async () => {
        const res = await axios.post(
          `${API_URL}/GetFileServlet?id=${file.id}`,
          {},
          {
            responseType: 'blob',
          }
        );
        downloadFile(res.data, extractFilename(res));
        if (onSuccess) {
          onSuccess();
        }
      },      
      {
        loading: 'Downloading',
        success: 'File downloaded.',
        error: (err) => `Operation unsuccessful : ${getErrorMessage(err)}`
      }
    )          
  }

  if (! (file && file.id)) {
    return <></>
  }

  return(
  <div className="d-flex flex-row justify-content-start align-items-start gap-2"  onClick={onDownloadFile}>
    <div className='fw-bolder fs-7 text-dark text-hover-primary' title="Download">
      {(file && file.fileName) ? file.fileName : ''}
    </div>
    <div className='text-dark text-hover-primary' title="Download " >
      <KTSVG
        path='/media/icons/duotune/arrows/arr091.svg'
        className='svg-icon-3'
      />
    </div>
  </div>
  )
}